/**
 * @generated SignedSource<<9860bb9f866b0922858fac1f6024c511>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type onboardingStateKey$data = {
  readonly key: string;
  readonly value: string | null | undefined;
  readonly " $fragmentType": "onboardingStateKey";
};
export type onboardingStateKey$key = {
  readonly " $data"?: onboardingStateKey$data;
  readonly " $fragmentSpreads": FragmentRefs<"onboardingStateKey">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "onboardingStateKey",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ],
  "type": "OnboardingState"
};

(node as any).hash = "8ed5c5c93198fee30eb8596c96216e7a";

export default node;
